import { render, staticRenderFns } from "./BnCmdFourDetail.vue?vue&type=template&id=b0b4cad2&"
import script from "./BnCmdFourDetail.vue?vue&type=script&lang=js&"
export * from "./BnCmdFourDetail.vue?vue&type=script&lang=js&"
import style0 from "./BnCmdFourDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports